export default __webpack_public_path__ + "static/media/screen_livechat_13.2f955158.png";